module.exports = __webpack_public_path__ + "img/Ross_County_FC.63c82b75.webp";